import { ChevronRightOutlined } from "@aircall/icons";
import { Flex, Typography } from "@aircall/tractor";
import { AnimationProps, motion } from "framer-motion";

import { EvaluationPercentage } from "../EvaluationPercentage";

import { EvaluationAccordionHeaderContentProps } from ".";

export function EvaluationAccordionHeaderContent({
  title,
  maximumPoints: maxValue,
  points: value,
  disabled = false,
  open = false,
  icon: Icon = <ChevronRightOutlined size={24} />,
  ...flexProps
}: EvaluationAccordionHeaderContentProps) {
  const animate: AnimationProps["animate"] = { rotate: open ? 90 : 0 };

  return (
    <Flex
      flex={1}
      alignItems="center"
      justifyContent="space-between"
      gap="xxs"
      p="s"
      cursor="pointer"
      {...flexProps}
    >
      <Typography variant="headingBoldXS">{title}</Typography>
      <Flex alignItems="center" gap="xxs">
        {maxValue ? (
          <EvaluationPercentage
            points={value}
            maximumPoints={maxValue}
            disabled={disabled}
          />
        ) : null}
        <motion.div
          style={{
            cursor: "pointer",
          }}
          animate={animate}
        >
          {Icon}
        </motion.div>
      </Flex>
    </Flex>
  );
}
